export enum LogTicketEnum {
    MODULE_ACCESS = 'View'
}